import { useState,useEffect} from 'react'
import {useDispatch} from 'react-redux'
import { setName } from './redux/UserSlice.js';
import {SeidrContainer,SeidrPoly,Loading} from '../src/styles/style.js';
import {Amplify,Auth} from 'aws-amplify'
import {ThemeProvider} from 'styled-components';
import { Copyright } from '../src/styles/style.js';
import { darkTheme, lightTheme } from './styles/Theme';
import Login from './components/Login'
import Navigation from './components/Navigation';
import {config} from './Config/config.js'
import LinkExam from './components/LinkExam';
import {Routes,Route,useNavigate} from 'react-router-dom';
import Home from './components/Home';
import Exams from './components/Exams';
import Scores from './components/Scores'
import Checkup from './components/Checkup'
import ProtectedRoute from './components/PageHelp/ProtectedRoute';
import * as AWS from 'aws-sdk'
import Portal from './API/Portal';

const pages = ['/home','/exams','/scores','/checkup']
const logoTop = '317.47,16.455 19.75,16.455 19.75,182.455 232.71,182.455';
const logoBottom = '0,269.5 297.72,269.5 297.72,103.5 84.76,103.5';

var endPoint;
if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" 
    || window.location.hostname === ""){
    endPoint = 'http://127.0.0.1:3600'
}else{
    endPoint = 'https://f7rr17ojuf.execute-api.us-east-2.amazonaws.com/Production'
}

var authEndPoint;
if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" 
    || window.location.hostname === ""){
    authEndPoint = 'http://127.0.0.1:3600'
}else{
    authEndPoint = ''
}

Amplify.configure({
    Auth:{
        mandatorySignIn: false,
        //identityPoolId: config.identityPoolId,
        region: config.region, 
        userPoolId: config.userPoolId, 
        userPoolWebClientId: config.userPoolWebClientId,
    },
    API: {
        endpoints: [
            {
                name: "Patient",
                endpoint: endPoint
            },
            {
                name: 'PatientAuth',
                endpoint:authEndPoint
            }
        ]
    }
});

AWS.config.update({
    region: config.region,
})
const portal = new Portal();
export default function App(props){
    const [loading,setLoading] = useState(true);
    const [theme,setTheme] = useState('Dark');
    const [linkExam,setLinkExam] = useState(true);
    const [isAuthorized,setIsAuthorized] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    async function readAccount(){
        setLoading(true);
        var data = await portal.readAccount();
        dispatch(setName(data.firstName + ' ' + data.lastName))
        setLoading(false);
    }

    useEffect(()=>{
        async function checkAuthorization(){
            var pathName = window.location.pathname;
            await Auth.currentSession().then( response => {
                var params = {
                    AccessToken: response.accessToken.getJwtToken()/* required */
                };
                var cognito = new AWS.CognitoIdentityServiceProvider();
                cognito.getUser(params,(err,data) =>{
                    if(err){
                        setIsAuthorized(false)
                    }else{
                        setIsAuthorized(true)
                        navigate(pathName)
                    }
                })
            }).catch((err) => {
                setIsAuthorized(false)
            });
        }

        document.body.style.backgroundColor = darkTheme.colors.background;
        //if(window.location.pathname !== '/' && !pages.includes(window.location.pathname)){
            
        //}else if(window.location.pathname === '/'){
            //setLoading(false)
            //setLinkExam(false)
        //}else{
            //checkAuthorization();
            //setLinkExam(false)
            //readAccount();
        //}
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])

    const changeTheme = e =>{
        if(theme === 'Dark'){
            setTheme('Light')
            document.body.style.backgroundColor = lightTheme.colors.background;
        }else{
            setTheme('Dark')
            document.body.style.backgroundColor = darkTheme.colors.background;
        }
    }

    function handleLoading(loadingState){
        setLoading(loadingState)
    }

    const handleLogin = e =>{
        setIsAuthorized(true);
        readAccount();
        navigate('/home')
    }   


    return(
        <ThemeProvider theme={theme === 'Dark' ? darkTheme : lightTheme}>
            {loading &&
                <Loading>
                    <SeidrContainer>
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" 
                        x="0px" y="0px" width="150px" height="298px" viewBox="-4.5 -6.5 326 298" 
                        enableBackground="new -4.5 -6.5 326 298" >
                            <g>
                                <SeidrPoly className='fast' points={logoTop}/>
                                <SeidrPoly className='slow'points={logoBottom}/>
                            </g>
                        </svg>
                    </SeidrContainer>
                </Loading>
            }

            {linkExam &&
                <>
                    <LinkExam type='link' loading={handleLoading} theme={theme} changeTheme={changeTheme}></LinkExam>
                </>
            }
            
            {!linkExam && !loading && 
                <>
                    {window.location.pathname !== '/' &&
                        <Navigation theme={theme} changeTheme={changeTheme} showNavigation={true}></Navigation>
                    }

                    <Routes>
                        <Route exact path='/' element={<Login successfulLogin={handleLogin}/>}/>
                        <Route element={<ProtectedRoute isAuthorized={isAuthorized}/>}> 
                            <Route exact path='/home' element={<Home/>}/>
                            <Route exact path='/exams' element={<Exams/>}/>
                            <Route exact path='/scores' element={<Scores/>}/>
                            <Route exact path='/checkup' element={<Checkup/>}/>
                        </Route>
                    </Routes>

                    <Copyright>
                        © {new Date().getFullYear()} BHTI
                    </Copyright>
                </>
            }
        </ThemeProvider>
    )
}